var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-shade-card',{staticClass:"r-tab-card"},[_c('div',{staticClass:"tabs h-box"},_vm._l((_vm.tabs),function(tab,i){return _c('div',{key:i,staticClass:"tab",class:_vm.styles(i),on:{"click":function($event){_vm.active = i}}},[_vm._v(" "+_vm._s(tab)+" ")])}),0),_c('div',{staticClass:"page"},[_vm._t(_vm.active)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }